// extracted by mini-css-extract-plugin
export var alertCards = "_2-0";
export var card = "_2-1";
export var fade = "_2-2";
export var hidden = "_2-3";
export var progressBar = "_2-4";
export var roundtime = "_2-5";